<template>
    <div class="modal" :class="{ 'is-active' : isActive }">
        <div class="modal-background" @click="closeSInvoiceModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Select Consignee</p>
                <button class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <article class="message is-danger" v-if="error.status">
                    <div class="message-body">
                        {{ error.message }}
                    </div>
                </article>
                <div class="select" :class="{ 'is-loading' : isLoading }">
                    <select v-model="selectedConsignee">
                        <option :value="null" disabled>Select Consignee</option>
                        <option v-for="consignee in consignees" :value="consignee.id">{{ consignee.name }} {{ consignee.street }}, {{ consignee.city }}, {{ consignee.country }}, {{ consignee.phone }}, {{ consignee.email }}</option>
                    </select>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" :class="{ 'is-loading' : isLoading }" @click="createSInvoice" :disabled="isDisabled">Save changes</button>
                <button class="button" @click="closeSInvoiceModal">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import apiSInvoice from '../../../../../api/apiSInvoices'
    import apiConsignees from '../../../../../api/apiConsignees'
    export default {
        data() {
           return {
               isLoading: false,
               consignees: [],
               selectedConsignee: null,
               error: {
                   status: false,
                   message: null
               }
           }
        },
        computed: {
            isActive() {
                return this.$store.getters.getSInvoiceModalStatus
            },
            isDisabled() {
                return this.selectedConsignee === null
            }
        },
        methods: {
            createSInvoice() {
                this.error.status = false
                this.error.message = null
                this.isLoading = true
                let data = {
                    consignee: this.selectedConsignee,
                    car_ids: this.$store.getters.getShippingGroupCars
                }
                apiSInvoice
                    .sInvoiceExportInEXCELRequest(data)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                        const link = document.createElement('a')
                        link.href = url
//                        const name = Number(state.proforma.id).toString().padStart(6, 0)
                        link.setAttribute('download', 'si.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        this.closeSInvoiceModal()
                        this.isLoading = false
                    })
                    .catch((error) => {
                        const blb    = new Blob([error.response.data], {type: "text/plain"});
                        const reader = new FileReader();

                        // This fires after the blob has been read/loaded.
                        reader.addEventListener('loadend', (e) => {
                            const text = e.srcElement.result;
                            this.error.status = true
                            this.error.message = JSON.parse(text).no_cbm
                        });

                        reader.readAsText(blb);

                        this.isLoading = false
                    })
            },
            closeSInvoiceModal() {
                this.$store.dispatch('setSInvoiceModalStatus', false)
            }
        },
        mounted() {
            this.isLoading = true
            apiConsignees
                .consigneesListRequest(this.$route.params.id)
                .then((response) => {
                    this.consignees = response.data
                    this.isLoading = false
                })
                .catch(error => console.log(error))

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/Garage/SInvoiceModal.vue